import { component } from 'picoapp';
import { buildProductItems } from '~/js/utils/product-item';
import quickBuyPopupTmpl from '~/js/lib/quick-buy-popup-tmpl';

import app from '~/app';

export default component(async (node, ctx) => {
  const { shared, sectionId } = node.dataset;
  const isShared = shared === 'true';
  const output = node.querySelector('[data-output]');
  const popupContainer = node.querySelector('[data-popup-container]');
  let wkReady = ctx.getState().wkLoaded;

  const fetchList = () => {
    if (isShared) return window.WishlistKing.toolkit?.sharedWishlists?.get();
    return window.WishlistKing.toolkit?.collection?.get();
  };

  const initWishlist = () => {
    wkReady = true;

    fetchList()
      .then((res) => {
        const products = res instanceof Array ? res[0].products : res.products;

        if (products.length) {
          output.innerHTML = buildProductItems(products, 'quick', 'wishlist', sectionId);
          const rows = {
            desktop: Math.ceil(products.length / 4),
            mobile: Math.ceil(products.length / 2),
          };
          const wishlistBanner = document.getElementById('wishlist-banner');
          if (wishlistBanner) {
            const clone = wishlistBanner.content.cloneNode(true);

            const { rowStart } = clone.firstElementChild.dataset;
            const start = parseInt(rowStart, 10);

            if (window.matchMedia('(min-width: 1024px)').matches) {
              if (start <= rows.desktop) {
                output.appendChild(clone);
              }
            } else if (start <= rows.mobile) {
              output.appendChild(clone);
            }
          }
          const items = [...output.querySelectorAll('[data-wishlist-item]')];
          ctx.emit('wishlist:fetched', ({ wishlist: res }));

          if (popupContainer) {
            let popups = '';

            products.forEach((product) => {
              popups += quickBuyPopupTmpl(product, 'wishlist', sectionId);
            });

            popupContainer.innerHTML = popups;
          }

          app.mount();

          if (items.length) {
            items.forEach((item) => {
              const { wishlistItem: itemId } = item.dataset;
              const removeBtn = item.querySelector('[data-remove-wishlist-item]');

              if (removeBtn && itemId) {
                removeBtn.addEventListener('click', () => {
                  window.WishlistKing.toolkit.removeItem(itemId);
                  initWishlist();
                });
              }
            });
          }
        } else {
          output.innerHTML = window.theme.strings.empty_wishlist;
        }
      });
  };

  if (wkReady) {
    initWishlist();
  } else {
    ctx.on('wishlist:loaded', initWishlist);
  }

  ctx.on('wishlist:updated', initWishlist);
});
